<template>
    <section>
        <div id="socialContainer" class="mt-3 d-flex justify-content-center">
            <button id="btnHeart" :class="likes ? 't-color-red' : 't-color-whiteDisabled'" class="typography--b4 mdc-button d-flex mgr-8" tabindex="0"
                    @click="onLike" @keypress="onLike"><i class="material-icons t-headline12 mgr-8 font-26">favorite</i><span class="t-body6 font-rn t-color-whiteHigh">{{likesCount}}</span>
            </button>
            <button id="btnBookmark" :class="clipping ? 't-color-contentBlue' : 't-color-whiteDisabled'" class="typography--b4 mdc-button d-flex" tabindex="0"
                    @click="onBookmark" @keypress="onBookmark"><i class="material-icons t-headline12  mgr-8 font-26">bookmark</i><span class="t-body6 font-rn t-color-whiteHigh">{{clippingCount}}</span>
            </button>
        </div>
    </section>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 좋아요/북마크 컴포넌트(my learning lesson study - like/bookmark component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import microLearnApi from '@/api/microLearnApi.js'
import {MDCRipple} from '@material/ripple'

export default {
    props: ['likesCount', 'clippingCount', 'likes', 'clipping'],

    mounted() {
      this.setMaterialUi()
    },

    methods: {
        // API 파라미터 설정(set parameter)
        setParams() {
            let params = {
                learnId: this.$route.params.learnId,
                progressionId: this.$route.params.progressionId
            }
            return params;
        },

        // 좋아요 API 호출(set/cancel like)
        onLike() {
            let params = this.setParams()
            let responseData = null
            if (this.likes) {
                microLearnApi.learnLessonLikesDelete(params).then((response) => {
                    responseData = response.data.data
                    this.$emit('updateLikesCount', {
                        likes: responseData,
                        likesCount: this.likesCount - 1
                    })
                    this.toggleLikeIcon()
                }).catch((err) => {

                })
            } else {
                microLearnApi.learnLessonLikesPost(params).then((response) => {
                    responseData = response.data.data
                    this.$emit('updateLikesCount', {
                        likes: responseData,
                        likesCount: this.likesCount + 1
                    })

                    this.toggleLikeIcon()
                }).catch((err) => {

                })
            }
        },

        // 북마크 API 호출(set/cancel bookmark)
        onBookmark() {
            let params = this.setParams()
            let responseData = null
            if (this.clipping) {
                microLearnApi.learnLessonClippingDelete(params).then((response) => {
                    responseData = response.data.data
                    this.$emit('updateBookmarkCount', {
                        clipping: responseData,
                        clippingCount: this.clippingCount - 1
                    })
                    this.toggleBookmarkIcon()
                }).catch((err) => {})
            } else {
                microLearnApi.learnLessonClippingPost(params).then((response) => {
                    responseData = response.data.data
                    this.$emit('updateBookmarkCount', {
                        clipping: responseData,
                        clippingCount: this.clippingCount + 1
                    })
                    this.toggleBookmarkIcon()
                }).catch((err) => {})
            }
        },

        // 좋아요 UI 노출(toggle like icon)
        toggleLikeIcon() {
            const element = this.$refs.likeIcon
            element.classList.add('fade', 'show')
            setTimeout(() => {
                element.classList.add('hide');
                setTimeout(() => {
                    element.classList.remove('fade', 'show', 'hide')
                }, 300)
            }, 1000 + 300)
        },

        // 북마크 UI 노출(toggle bookmark icon)
        toggleBookmarkIcon() {
            const element = this.$refs.bookmarkIcon
            element.classList.add('fade', 'show')
            setTimeout(() => {
                element.classList.add('hide');
                setTimeout(() => {
                    element.classList.remove('fade', 'show', 'hide')
                }, 300)
            }, 1000 + 300)
        },

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
}
</script>
